// brand colors
export const mondooPurple = {
  main: "#9147FF",
  light: "#A07AFF",
  dark: "#5000C1",
  darker: "#3F137C",
  gradient: "linear-gradient(to bottom right, #9147FF 0%, #4C35E8 100%)",
};

export const mondooBlue = {
  main: "#4C35E8",
  light: "#8797FF",
  lighter: "#CCD3FF",
  dark: "#2A15B7",
  darker: "#19105C",
  gradient: "linear-gradient(to bottom right, #4C35E8 0%, #8797FF 100%)",
};

// semantic colors
export const error = {
  main: "#FF5252",
  light: "#FF7070",
  lighter: "#FFCBCB",
  dark: "#4F0808",
  gradient: "linear-gradient(to left, #FF5252 0%, #FF7070 100%)",
};

export const warning = {
  main: "#FBD153",
  light: "#FFED9F",
  dark: "#755800",
  gradient: "linear-gradient(to left, #FBD153 0%, #FFED9F 100%)",
};

export const info = {
  main: "#0288d1",
  light: "#03a9f4",
  dark: "#01579b",
};

export const success = {
  main: "#2e7d32",
  light: "#4caf50",
  dark: "#1b5e20",
};

// score colors
export const critical = {
  main: "#FC3779",
  light: "#FD6094",
  dark: "#DF074F",
  gradient: "linear-gradient(to left, #FD5CA4 0%, #FF7AB6 100%)",
};

export const high = {
  main: "#CF2584",
  light: "#DD519F",
  dark: "#BA2177",
  gradient: "linear-gradient(to left, #CF2584 0%, #DD519F 100%)",
};

export const medium = {
  main: "#039CD8",
  light: "#33C3FB",
  dark: "#0278A6",
  gradient: "linear-gradient(to left, #039CD8 0%, #33C3FB 100%)",
  fairGradient: "linear-gradient(to left, #33C3FB 0%, #33C3FB 100%)",
};

export const low = {
  main: "#2CBFC9",
  light: "#5FD4DB",
  dark: "#167C83",
  gradient: "linear-gradient(to left, #2CBFC9 0%, #5FD4DB 100%)",
};

export const none = {
  main: "#2FC089",
  light: "#6CD9AF",
  dark: "#238B66",
  gradient: "linear-gradient(to left, #2FC089 0%, #6CD9AF 100%)",
};

export const unknown = {
  main: "#CCCCCC",
  light: "#D9D9D9",
  dark: "#696969",
  gradient: "linear-gradient(to left, #CCCCCC 0%, #D9D9D9 100%)",
};

export const errorScan = {
  main: "#FF7849",
  light: "#FE936E",
  dark: "#A42200",
  gradient: "linear-gradient(to left, #FF7849 0%, #FE936E 100%)",
};

// neutral colors
export const white = "#FFFFFF";
export const black = "#000000";
